import React from 'react';

// "Local vs Visitante" con el lado del jugador (individual o pareja) en negrita.
export default function PartidoVs({ partido }) {
  const mio = (lado) => partido.lado === lado;
  return (
    <span className="ap-partido">
      {mio('LOCAL') ? <strong>{partido.local}</strong> : partido.local}
      {' vs '}
      {mio('VISITANTE') ? <strong>{partido.visitante}</strong> : partido.visitante}
    </span>
  );
}
